export const organisations: TableModule = {
    name: "organisations",
    route: "spa.system.organisations",
    columns: [
        {
            name: "id",
            sortable: true,
            width: "w-[75px]",
        },
        {
            name: "name",
            pageLink: true,
            sortable: true,
            sortBy: "name",
            mobile: true
        },
        {
            name: "email",
            sortable: true,
            breakpoint: "md"
        },
        {
            name: "address",
            sortable: true,
            sortBy: "organisations.zip",
        },
        {
            name: "tax_type",
            sortable: true,
            width: "w-[150px]",
            breakpoint: "lg"
        },
        {
            name: "last_login_at",
            sortable: true,
            width: "w-[150px]",
            breakpoint: "xl"
        },
        {
            name: "status",
            sortable: false,
            mobile: true,
            truncate: false,
            width: "w-[125px]"
        }
    ],
    filters: [
        {
            name: "id",
            column: "organisations.id",
            type: "numeric"
        },
        {
            name: "name",
            column: "organisations.name",
            type: "string",
            reduced: true
        },
        {
            name: "active",
            column: "organisations.active",
            type: "boolean",
            reduced: true
        },
        {
            name: "billing_enabled",
            column: "organisations.billing_enabled",
            type: "boolean"
        },
        {
            name: "customFilterHasAmoswebAddon",
            column: "customFilterHasAmoswebAddon",
            type: "boolean"
        },
        {
            name: "email",
            column: "organisations.email",
            type: "string"
        },
        {
            name: "tax_type",
            column: "organisations.tax_type",
            type: "select",
            options: () => [
                {value: 'internal', label: useNuxtApp().$i18n.t('baseData.taxTypes.internal')},
                {value: 'default', label: useNuxtApp().$i18n.t('baseData.taxTypes.default')},
                {value: 'assistance', label: useNuxtApp().$i18n.t('baseData.taxTypes.assistance')}
            ]
        },
        {
            name: "last_login_at",
            column: "organisations.last_login_at",
            type: "date",
        }
    ],
    quickFilters: [
        {
            name: "qf_onlyActive",
            column: "organisations.active",
            value: ["1"],
            operator: "="
        },
        {
            name: "qf_withAmoswebAddon",
            column: "customFilterHasAmoswebAddon",
            value: ["1"],
            operator: "="
        }
    ],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "organisations"]
        },
        {
            name: "organisations.billing",
            color: "rose"
        },
        {
            name: "general.export",
            ability: ["viewAny", "organisations"]
        }
    ]
}
